import { createGlobalStyle, css, DefaultTheme } from "styled-components";
import { Colors } from "./styled";

const MEDIA_WIDTHS = {
  upToXxs: 480,
  upToExtraSmall: 629,
  upToSmall: 790,
  upToMedium: 960,
  upToLarge: 1280,
  upToExtraLarge: 2160,
};

const mediaWidthTemplates: {
  [width in keyof typeof MEDIA_WIDTHS]: typeof css;
} = Object.keys(MEDIA_WIDTHS).reduce((accumulator, size) => {
  (accumulator as any)[size] = (a: any, b: any, c: any) => css`
    @media only screen and (max-width: ${(MEDIA_WIDTHS as any)[size]}px) {
      ${css(a, b, c)}
    }
  `;
  return accumulator;
}, {}) as any;

const themeSpacing = (spacing: number | string | undefined) =>
  spacing === undefined
    ? ""
    : typeof spacing === "string"
    ? spacing
    : spacing * 4 + "px";

const fontWeight = {
  light: 300,
  regular: 400,
  bold: 500,
};

const borderRadius = {
  smallest: "8px",
  small: "12px",
  smaller: "14px",
  medium: "16px",
  larger: "18px",
  large: "20px",
  largest: "24px",
};

export const colors: Colors = {
  primary60: "#DDAF38",
  primary40: "#F5C23E",
  primary20: "#F6C851",
  primary00: "#F8D478",

  secondary60: "#436171",
  secondary40: "#54798D",
  secondary20: "#658698",
  secondary00: "#87A1AF",

  neutral100: "#000000",
  neutral80: "#A0A0A0",
  neutral60: "#C8C8C8",
  neutral40: "#E6E6E6",
  neutral20: "#F1F1F1",
  neutral00: "#FFFFFF",
};

export const fontStyle = {
  display: css`
    font-size: 72px;
  `,
  primary: css`
    font-style: normal;
    font-weight: 400;
    font-size: 20px;
    line-height: 155%;
  `,
  secondary: css`
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 155%;
  `,
  button: css`
    font-family: Oswald, sans-serif;
    font-size: 18px;
    font-weight: 700;
  `,
};

export const theme = (): DefaultTheme => {
  return {
    mediaWidth: mediaWidthTemplates,
    spacing: themeSpacing,
    colors,
    fontWeight,
    borderRadius,
    fontStyle,
  };
};

export const FixedGlobalStyle = createGlobalStyle`
* {
  box-sizing: border-box;
}

html, input, textarea {
  font-family: Poppins, sans-serif;
  font-display: auto;
}

@supports (font-variation-settings: normal) {
  html, input, textarea {
    font-family: Poppins, sans-serif;
  }
}

html,
body {
  margin: 0;
  padding: 0;
  font-family: Poppins, sans-serif;
}

html {
  scroll-snap-type: y mandatory;
  scroll-behavior: smooth;
  color: ${colors.neutral100};
  font-size: 16px;
  font-variant: none;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  font-feature-settings: 'ss01' on, 'ss02' on, 'cv01' on, 'cv03' on;
}

h1, h2, h3, h4, h5, h6{
  font-family: Oswald, sans-serif;
  font-style: normal;
  font-weight: 700;
  text-transform: uppercase;
  line-height: 125%;
  margin: 0;
}

p{
  margin: 0;
}

h1{
  font-size: 46px;
}

h2{
  font-size: 28px;
}

h3{
  font-size: 18px;
}
nav, button{
  font-family: Oswald, sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  text-transform: uppercase;
  background: none;
  border: none;
  padding: 0;
}

a{
  text-decoration: none;
  color: ${colors.neutral100};
  cursor: pointer;
}

`;
